const constants = {
    MASTER_DASHBOARD_CHART_TYPE: {
        RESIN_USAGE: 'resinUsage',
        PRINT_FREQUENCY: 'printFrequency',
        PRINT_OUTCOME: 'printOutcome',
        PRINT_TIME: 'printTime',
        PRINT_TIME_AND_RESIN_USAGE: 'printTimeAndResinUsage',
        RESIN_USED: 'resinUsed',
        THICKNESS: 'thickness',
        PRINT_OVERVIEW: 'printOverview'
    },
    UPGRADE_ACCOUNT_LINK: '/account',
    SELECTED_PAGE: {
        PRINTED_MODELS_PANEL: 0,
        PRINTERS_PANEL: 1,
        MATERIAL_USAGEP_PANEL: 2,
        ACCOUNT_SETTING_PAGE: 3,
        PRINTER_CONNECTING_TUTORIAL: 4  
    },
    print_feedback: Object.freeze({
        yes: 1,
        no: 2,
        dismiss: 3
    })
};
module.exports = constants;



// WEBPACK FOOTER //
// ./src/common/constants.js